import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  urlBar: {
    background: '#16213e',
    padding: '14px 32px',
    borderBottom: '1px solid #0f3460',
  },
  urlRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
  urlBarLabel: {
    color: '#94a3b8',
    fontSize: '0.78rem',
    fontWeight: 600,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  monthInput: {
    width: '160px',
    background: '#0f1f38',
    border: '1px solid #2d4a6e',
    borderRadius: '8px',
    '& input': {
      color: '#e2e8f0',
      padding: '9px 14px',
      fontFamily: "'SF Mono','Fira Code',monospace",
      fontSize: '0.88rem',
      textAlign: 'center',
      letterSpacing: '2px',
    },
    '& input::placeholder': {
      color: '#4a6080',
      opacity: 1,
    },
  },
  urlInput: {
    flex: 1,
    minWidth: '260px',
    background: '#0f1f38',
    border: '1px solid #2d4a6e',
    borderRadius: '8px',
    '& input': {
      color: '#e2e8f0',
      padding: '9px 14px',
      fontFamily: "'SF Mono','Fira Code',monospace",
      fontSize: '0.88rem',
    },
    '& input::placeholder': {
      color: '#4a6080',
      opacity: 1,
    },
  },
  headersInput: {
    minWidth: '200px',
    background: '#0f1f38',
    border: '1px solid #2d4a6e',
    borderRadius: '8px',
    '& input': {
      color: '#e2e8f0',
      padding: '9px 14px',
      fontFamily: "'SF Mono','Fira Code',monospace",
      fontSize: '0.82rem',
    },
    '& input::placeholder': {
      color: '#4a6080',
      opacity: 1,
    },
  },
  submitBtn: {
    padding: '9px 22px',
    background: 'linear-gradient(135deg,#2563eb,#1d4ed8)',
    color: '#fff',
    borderRadius: '8px',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    '&:hover': {
      opacity: 0.9,
    },
    '&:disabled': {
      opacity: 0.5,
    },
  },
  sampleBtn: {
    padding: '9px 18px',
    color: '#94a3b8',
    border: '1px solid #2d4a6e',
    borderRadius: '8px',
    fontSize: '0.85rem',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    '&:hover': {
      borderColor: '#4a90d9',
      color: '#e2e8f0',
    },
  },
  statsBar: {
    display: 'flex',
    gap: '14px',
    padding: '16px 32px',
    flexWrap: 'wrap',
  },
  statChip: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: '#fff',
    borderRadius: '10px',
    padding: '12px 20px',
    minWidth: '130px',
    flex: 1,
  },
  statVal: {
    fontSize: '1.4rem',
    fontWeight: 700,
  },
  statLbl: {
    fontSize: '0.68rem',
    opacity: 0.8,
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
    marginTop: '2px',
  },
  statSub: {
    fontSize: '0.72rem',
    marginTop: '3px',
    opacity: 0.9,
  },
  container: {
    padding: '20px 32px',
  },
  card: {
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 1px 6px rgba(0,0,0,0.07)',
    overflow: 'hidden',
  },
  tableWrap: {
    overflowX: 'auto',
    '& thead tr th:first-child': {
      position: 'sticky',
      left: 0,
      zIndex: 3,
      backgroundColor: '#2d4f6e',
    },
  },
  filterBar: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '12px 18px',
    borderBottom: '1px solid #f1f5f9',
  },
  searchInput: {
    width: '220px',
    background: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    '& input': {
      color: '#374151',
      padding: '7px 10px',
      fontSize: '0.84rem',
    },
    '& input::placeholder': {
      color: '#9ca3af',
      opacity: 1,
    },
  },
  filterSelect: {
    padding: '7px 14px',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '0.84rem',
    background: '#fff',
    color: '#374151',
    cursor: 'pointer',
  },
  selectPaper: {
    maxHeight: '300px',
    marginTop: '4px',
  },
  filterRight: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    marginLeft: 'auto',
  },
  exportBtn: {
    padding: '8px 16px',
    background: 'linear-gradient(135deg,#065f46,#059669)',
    color: '#fff',
    borderRadius: '8px',
    fontSize: '0.82rem',
    fontWeight: 700,
    '&:hover': {
      opacity: 0.88,
    },
    '&:disabled': {
      opacity: 0.5,
    },
  },
  tableHeader: {
    fontWeight: 700,
    backgroundColor: '#2d4f6e',
    whiteSpace: 'nowrap',
    color: '#FFE784',
    padding: '6px 12px',
    fontSize: '0.72rem',
    lineHeight: '1.2',
    letterSpacing: '0.3px',
    textTransform: 'uppercase',
  },
  isBold: {
    fontWeight: 700,
    color: '#FFFFFF',
  },
  sortContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '4px',
    cursor: 'pointer',
  },
  sortUp: {
    marginBottom: '-8px',
  },
  sortDown: {
    marginTop: '-4px',
  },
  active: {
    color: '#FFE784',
  },
  inactive: {
    color: '#7aa8c8',
  },
  emptyTableContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '150px',
  },
  titleWrapper: {
    whiteSpace: 'nowrap',
    fontSize: '0.8rem',
    textAlign: 'right',
  },
  expandRow: {
    background: '#f8fafc',
  },
  accountCell: {
    textAlign: 'left !important',
    position: 'sticky',
    left: 0,
    background: '#fff',
    zIndex: 1,
    borderRight: '1px solid #e5e7eb',
    minWidth: '210px',
  },
  acctName: {
    fontWeight: 600,
    fontSize: '0.82rem',
    color: '#1e293b',
  },
  acctId: {
    fontSize: '0.65rem',
    color: '#94a3b8',
    fontFamily: "'SF Mono','Fira Code',monospace",
    marginTop: '1px',
  },
  amountCell: {
    background: '#f0fdf4',
    borderLeft: '2px solid #86efac',
    fontWeight: 700,
    color: '#166534',
    minWidth: '100px',
    textAlign: 'right'
  },
  dash: {
    color: '#d1d5db',
  },
  curBadge: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '20px',
    fontSize: '0.7rem',
    fontWeight: 700,
  },
  curUsd: {
    background: '#f0fdf4',
    color: '#166534',
    border: '1px solid #86efac',
  },
  curEur: {
    background: '#eff6ff',
    color: '#1d4ed8',
    border: '1px solid #93c5fd',
  },
  curOther: {
    background: '#f9fafb',
    color: '#6b7280',
    border: '1px solid #e5e7eb',
  },
  currencyTotalCell: {
    background: '#fefce8',
    borderTop: '2px solid #fde68a',
    fontWeight: 700,
    fontSize: '0.78rem',
    color: '#92400e',
    whiteSpace: 'nowrap',
    textAlign: 'right'
  },
  currencyTotalAccountCell: {
    textAlign: 'left !important',
    position: 'sticky',
    left: 0,
    background: '#fefce8',
    zIndex: 1,
    borderRight: '1px solid #e5e7eb',
    borderTop: '2px solid #fde68a',
    fontWeight: 700,
    color: '#92400e',
  },
  currencyTotalAmountCell: {
    background: '#dcfce7',
    borderLeft: '2px solid #86efac',
    borderTop: '2px solid #fde68a',
    color: '#166534',
    fontWeight: 700,
    textAlign: 'right'
  },
  totalInvoiceCell: {
    background: '#f0fdf4',
    borderLeft: '2px solid #86efac',
    fontWeight: 700,
    color: '#065f46',
    minWidth: '110px',
    textAlign: 'right'
  },
  currencyTotalInvoiceCell: {
    background: '#dcfce7',
    borderLeft: '2px solid #86efac',
    borderTop: '2px solid #fde68a',
    color: '#065f46',
    fontWeight: 700,
    textAlign: 'right'
  },
  configBtn: {
    display: 'inline-block',
    padding: '2px 8px',
    fontSize: '0.65rem',
    background: '#e0e7ff',
    color: '#3730a3 !important',
    borderRadius: '4px',
    fontWeight: 600,
    margin: '0px !important',
    minWidth: 'unset',
    '&:hover': {
      background: '#c7d2fe',
    },
  },
  configExpandCell: {
    padding: '0 !important',
    background: '#f8fafc',
  },
  configExpandInner: {
    padding: '14px 22px 18px',
    borderTop: '1px solid #e0e7ff',
    borderBottom: '2px solid #c7d2fe',
  },
  configTitle: {
    fontSize: '0.72rem',
    color: '#6b7280',
    marginBottom: '10px',
    marginRight: '20px',
    textAlign: 'right',
  },
  configId: {
    fontFamily: 'monospace',
    fontSize: '0.68rem',
    color: '#94a3b8',
    marginLeft: '6px',
  },
  cfgGrid: {
    display: 'flex',
    gap: '20px',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  cfgSection: {
    minWidth: '160px',
  },
  cfgSectionTitle: {
    fontSize: '0.66rem',
    fontWeight: 700,
    letterSpacing: '0.8px',
    textTransform: 'uppercase',
    color: '#6b7280',
    marginBottom: '6px',
  },
  cfgTable: {
    borderCollapse: 'collapse',
    fontSize: '0.76rem',
  },
  cfgTableRow: {
    display: 'flex',
  },
  cfgTableCell: {
    padding: '3px 10px',
    border: '1px solid #e5e7eb',
    textAlign: 'left',
    color: '#6b7280',
    whiteSpace: 'nowrap',
    background: '#f1f5f9',
    minWidth: '120px',
  },
  cfgTableCellValue: {
    padding: '3px 10px',
    border: '1px solid #e5e7eb',
    textAlign: 'left',
    fontWeight: 600,
    color: '#1e293b',
    minWidth: '100px',
  },
  cfgRow: {
    display: 'flex',
    gap: '6px',
    fontSize: '0.76rem',
    minWidth: '200px',
    alignItems: 'center',
  },
  cfgKey: {
    color: '#6b7280',
    minWidth: '145px',
    flexShrink: 0,
  },
  cfgVal: {
    fontWeight: 600,
    color: '#1e293b',
  },
  boolYes: {
    color: '#166534',
    background: '#dcfce7',
    padding: '0 5px',
    borderRadius: '3px',
    fontSize: '0.68rem',
    fontWeight: 700,
  },
  boolNo: {
    color: '#991b1b',
    background: '#fee2e2',
    padding: '0 5px',
    borderRadius: '3px',
    fontSize: '0.68rem',
    fontWeight: 700,
  },
}))

export default useStyles
